import { ReduxStateType } from '../types';

export const getSelectedOptionSelector = (state: ReduxStateType) => {
	return state.option?.selectedOption;
};
